import { useState } from "react";
import { taskService } from "@miplatform/api";
import { AutocompleteOption } from "@miplatform/components";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IInspectionAttempt } from "@miplatform/types";
import { buildSearchQuery, createUUID } from "@miplatform/utils";

export type InspectionOption = AutocompleteOption & IInspectionAttempt;

const GET_INSPECTIONS_UUID = createUUID();

export const useInspectionSearch = ({ search }: { search: string }) => {
  const stateManager = useComponentState();
  const [inspectionOptions, setInspectionOptions] = useState<
    InspectionOption[]
  >([]);

  const getInspectionOptions = (): Promise<void> => {
    if (!search || search.length < 3) {
      setInspectionOptions([]);
      return Promise.resolve();
    }

    const searchQuery = buildSearchQuery(search, ["home.address.addressLine1"]);

    stateManager.abort(GET_INSPECTIONS_UUID);

    return stateManager.run(async () => {
      const { status, data } = await taskService.inspection.getAllAttempts({
        filters: {
          ...searchQuery,
        },
      });

      if (status === HTTP_STATUSES.OK) {
        setInspectionOptions(
          data.map((inspection: IInspectionAttempt) => ({
            ...inspection,
            label: inspection.home?.address?.addressLine1 ?? "",
            value: inspection.id,
          }))
        );
      }
    }, GET_INSPECTIONS_UUID);
  };

  return {
    getInspectionOptions,
    inspectionOptions,
    loading: stateManager.isBusy(),
  };
};
